<div class="vds-menu-item-selectable__checkmark-container">
    <vds-icon name="checkmark" />
</div>
<span class="vds-menu-item__label"><ng-content /></span>
